/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformStorageUsageSummaryResponse
 */
export interface PlatformStorageUsageSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    periodStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    periodEnd?: Date;
    /**
     * 
     * @type {number}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    bytesWritten?: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    effectiveRetentionDays?: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    estimatedProviderCostUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    estimatedCustomerCostUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformStorageUsageSummaryResponse
     */
    markupPercent?: number;
}

/**
 * Check if a given object implements the PlatformStorageUsageSummaryResponse interface.
 */
export function instanceOfPlatformStorageUsageSummaryResponse(value: object): value is PlatformStorageUsageSummaryResponse {
    return true;
}

export function PlatformStorageUsageSummaryResponseFromJSON(json: any): PlatformStorageUsageSummaryResponse {
    return PlatformStorageUsageSummaryResponseFromJSONTyped(json, false);
}

export function PlatformStorageUsageSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformStorageUsageSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'bytesWritten': json['bytesWritten'] == null ? undefined : json['bytesWritten'],
        'effectiveRetentionDays': json['effectiveRetentionDays'] == null ? undefined : json['effectiveRetentionDays'],
        'estimatedProviderCostUsd': json['estimatedProviderCostUsd'] == null ? undefined : json['estimatedProviderCostUsd'],
        'estimatedCustomerCostUsd': json['estimatedCustomerCostUsd'] == null ? undefined : json['estimatedCustomerCostUsd'],
        'markupPercent': json['markupPercent'] == null ? undefined : json['markupPercent'],
    };
}

export function PlatformStorageUsageSummaryResponseToJSON(json: any): PlatformStorageUsageSummaryResponse {
    return PlatformStorageUsageSummaryResponseToJSONTyped(json, false);
}

export function PlatformStorageUsageSummaryResponseToJSONTyped(value?: PlatformStorageUsageSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart']).toISOString()),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd']).toISOString()),
        'bytesWritten': value['bytesWritten'],
        'effectiveRetentionDays': value['effectiveRetentionDays'],
        'estimatedProviderCostUsd': value['estimatedProviderCostUsd'],
        'estimatedCustomerCostUsd': value['estimatedCustomerCostUsd'],
        'markupPercent': value['markupPercent'],
    };
}

